// extracted by mini-css-extract-plugin
export default {"container":"Overview_container__xgeYA","headingContainer":"Overview_headingContainer__0FNut","cardArea":"Overview_cardArea__KynX1"};